/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateCashbackInput = {|
  clientMutationId?: ?string,
  date: string,
  id: string,
  place: string,
  storeId: string,
|};
export type updateCashbackMutationVariables = {|
  input: UpdateCashbackInput
|};
export type updateCashbackMutationResponse = {|
  +updateCashback: ?{|
    +cashback: ?{|
      +id: string
    |},
    +errorMessage: ?string,
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type updateCashbackMutation = {|
  variables: updateCashbackMutationVariables,
  response: updateCashbackMutationResponse,
|};
*/


/*
mutation updateCashbackMutation(
  $input: UpdateCashbackInput!
) {
  updateCashback(input: $input) {
    cashback {
      id
    }
    errorMessage
    errors {
      key
      messages
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCashbackInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCashbackPayload",
    "kind": "LinkedField",
    "name": "updateCashback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Cashback",
        "kind": "LinkedField",
        "name": "cashback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messages",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCashbackMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCashbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateCashbackMutation",
    "operationKind": "mutation",
    "text": "mutation updateCashbackMutation(\n  $input: UpdateCashbackInput!\n) {\n  updateCashback(input: $input) {\n    cashback {\n      id\n    }\n    errorMessage\n    errors {\n      key\n      messages\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8e8e8144d34c61a8106028bfcac0ffea';

module.exports = node;
